import { Theme } from '@mui/material';
import TabIndicator from './TabIndicator';
// interface M3Tabs {
//     MuiTabs: {
//         defaultProps?: any;
//         styleOverrides?: any;
//         variants?: any;
//     };
// }

export const getTabs = (theme: Theme) => {
    const { palette } = theme;
    return {
        MuiTabs: {
            defaultProps: {
                TabIndicatorProps: {
                    children: TabIndicator(),
                },
            },
            styleOverrides: {
                root: {
                    '& .MuiTabs-indicator': {
                        height: 3,
                        display: 'flex',
                        justifyContent: 'center',
                        backgroundColor: 'transparent',
                    },
                    '& .MuiTabs-indicatorSpan': {
                        borderRadius: '3px 3px 0 0',
                        width: '100%',
                        marginRight: 16,
                        marginLeft: 16,
                        backgroundColor: palette.primary.main,
                    },
                    '& .MuiButtonBase-root': {
                        textTransform: 'none',
                    },
                },
            },
        },
    };
};
